import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ConfigData from "../config/config.json";
import { GlobalMessageContext } from "../app/App";

const webserver = ConfigData.WEBSERVER;

export default function SelectRole(props) {
  const { setGlobalMessage } = React.useContext(GlobalMessageContext);
  const handleChange = (event) => {
    if (
      props.name !== undefined &&
      props.name !== "" &&
      props.index !== undefined
    ) {
      fetch(
        webserver.protocol +
          "://" +
          webserver.host +
          ":" +
          webserver.port +
          "/user/setRole/" +
          props.name +
          "?role=" +
          event.target.value,
        { method: "PUT", credentials: "include" }
      )
        .then((response) => {
          if (response.status !== 200) {
            throw new Error(
              "Unable to access endpoint: user/setRole/" + props.name
            );
          } else {
            props.setRole((prev) => {
              let temp = JSON.parse(JSON.stringify(prev));

              temp[props.index].role = event.target.value;
              return temp;
            });
          }
          setGlobalMessage({
            globalMessage: "Änderung erfolgreich",
            severity: "success",
          });
          return response;
        })
        .catch((error) => {
          setGlobalMessage({
            globalMessage: "Vorgang fehlgeschlagen",
            severity: "error",
          });
        });
    } else {
      props.setRole(event.target.value);
    }
  };

  return (
    <FormControl sx={{ minWidth: 120 }} size="small">
      <InputLabel>Rolle</InputLabel>
      <Select
        value={props.role}
        label="Rolle"
        onChange={(e) => handleChange(e)}
        sx={{ color: props.role === "BLAK_EMPLOYEE" && "#009fe3" }}
      >
        <MenuItem value="EXAMINER">Prüfer</MenuItem>
        <MenuItem value="BLAK_EMPLOYEE" sx={{ color: "#009fe3" }}>
          BLAK
        </MenuItem>
      </Select>
    </FormControl>
  );
}
